import React from 'react';
import './Spinner.css';
const Spinner = (props) => {
    return (
        <div className="dot-loader">
            <div className="dot" style={{backgroundColor: props.color}}></div>
            <div className="dot" style={{backgroundColor: props.color}}></div>
            <div className="dot" style={{backgroundColor: props.color}}></div>
        </div>
    );
}

export default React.memo(Spinner);
